/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {ListsWidget26} from '../../../_metronic/partials/widgets'

const DashboardPage: FC = () => (
  <>
    {/* top row remains unchanged */}
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <ListsWidget26
          className='h-lg-auto mb-6'
          title='Company'
          rows={[{description: 'Company List', url: '/companies'}]}
        />
        <ListsWidget26
          className='h-lg-auto mb-6'
          title='Product Master'
          rows={[
            {description: 'Group', url: '/products/group'},
            {description: 'Ledger', url: '/products/ledger'},
            {description: 'Voucher Type', url: '/products/voucher-type'},
            {description: 'Currency', url: '/products/currency'},
          ]}
        />
      </div>

      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <ListsWidget26
          className='h-lg-90 mb-6'
          title='Enter Transactions'
          rows={[
            {description: 'Journal', url: '/transactions/enter/journal'},
            {description: 'Receipt', url: '/transactions/enter/receipt'},
            {description: 'Payment', url: '/transactions/enter/payment'},
            {description: 'Contra', url: '/transactions/enter/contra'},
            {description: 'Sales', url: '/transactions/enter/sales'},
            {description: 'Purchase', url: '/transactions/enter/purchase'},
            {description: 'Debit Note', url: '/transactions/enter/debitnote'},
            {description: 'Credit Note', url: '/transactions/enter/creditnote'},
          ]}
        />
      </div>

      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <ListsWidget26
          className='h-lg-auto mb-6'
          title='Reports'
          rows={[
            {description: 'Trial Balance', url: '/transactions/trial-balance'},
            {description: 'Aging Report', url: '/transactions/aging-report/'},
            {description: 'P&L Report', url: '/profitandloss'},
            {description: 'Balance Sheet', url: '/balancesheet'},
            {description: 'Register', url: '/register'},
          ]}
        />

        <ListsWidget26
          className='h-lg-auto '
          title='Settings'
          rows={[{description: 'User Settings', url: '/settings'}]}
        />
      </div>

      <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
        <ListsWidget26
          className='h-lg-85 mb-6'
          title='View Transactions'
          rows={[
            {description: 'Journal', url: '/transactions/view/journal'},
            {description: 'Receipt', url: '/transactions/view/receipt'},
            {description: 'Payment', url: '/transactions/view/payment'},
            {description: 'Contra', url: '/transactions/view/contra'},
            {description: 'Sales', url: '/transactions/view/sales'},
            {description: 'Purchase', url: '/transactions/view/purchase'},
            {description: 'Debit Note', url: '/transactions/view/debitnote'},
            {description: 'Credit Note', url: '/transactions/view/creditnote'},
          ]}
        />
      </div>
    </div>

    {/* begin::Row - Dedicated Inventory Section */}
    <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
      <div className='col-md-4 col-xl-4 mb-md-5 mb-xl-10'>
        <ListsWidget26
          className='h-lg-auto'
          title='Inventory Management'
          rows={[
            {description: 'Warehouse Management', url: '/warehouse-management'},
            {description: 'Product Catalogue', url: '/product-catalogue/manage-products'},
            {description: 'Stock Management', url: '/stock/initial-assignment'},
            {description: 'Returns Management', url: '/returns-management'},
          ]}
        />
      </div>

      {/* NEW DEDICATED SECTION */}
      <div className='col-md-4 col-xl-4 mb-md-5 mb-xl-10'>
        <ListsWidget26
          className='h-lg-auto'
          title='Inventory Reports'
          rows={[
            {description: 'Stock Levels Dashboard', url: '/stock-levels'},
            {description: 'Stock Valuation Report', url: '/stock-valuation'},
            {description: 'Inventory Ageing Report', url: '/inventory-ageing'},
            {description: 'Return & Scrap Summary', url: '/return-scrap'},
            {description: 'Movement Report', url: '/movement-report'},
            {description: 'Profitability Report', url: '/profitability-report'},
          ]}
        />
      </div>

      <div className='col-md-4 col-xl-4 mb-md-5 mb-xl-10'>
        <ListsWidget26
          className='h-lg-auto'
          title='Cost / Profit Center'
          rows={[
            {description: 'Cost Center Management', url: '/cost-center-management'},
            {description: 'Profit Center Management', url: '/profit-center-management'},
            {description: 'Expense Management', url: '/expense-management'},
          ]}
        />
      </div>
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
